import { Component } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { EmergencyContact } from '../../models/emergency-contact';
import { EmergencyContactService } from '../../services/emergency-contact.service';

@Component({
  selector: 'app-edit-emg-contact-wrapper',
  templateUrl: './edit-emg-contact-wrapper.component.html',
  styleUrls: ['./edit-emg-contact-wrapper.component.scss']
})
export class EditEmgContactWrapperComponent extends ComponentBase {

  constructor(private emergencyContactService: EmergencyContactService) { super(); }
  emergency_contact: EmergencyContact;
  ngOnInit() {
    let sub = this.emergencyContactService.getEmergencyContactForStudent()
      .subscribe((emgContact) => {
        this.emergency_contact = emgContact;
      });
    this.addSubscription(sub);
  }

}
